import React, { useState } from 'react';
import { Label } from './Label';
import DatePicker from './DatePicker';
import FilterPanel from './FilterPanel';
import FilterActions from './FilterActions';

const DataFilter = ({ config, filters, onChange, onClear, onSearch }) => {
  const [isOpen, setIsOpen] = useState(true);
  const advancedFilters = config.filter((field) => field.advanced);

  return (
    <FilterPanel
      title="Filters"
      isOpen={isOpen}
      onToggle={advancedFilters.length > 0 ? () => setIsOpen(!isOpen) : undefined}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-6 gap-6 mb-4">
        {config.map((field) => {
          if (field.advanced && !isOpen) return null;
          if (field.hidden) return null;

          return (
            <div key={field.name} className="space-y-1">
              <Label className="text-xs font-medium text-gray-700 dark:text-gray-300">
                {field.label}
              </Label>

              {field.type === 'select' && (
                <select
                  value={Array.isArray(filters[field.name]) ? (filters[field.name][0] || '') : (filters[field.name] || '')}
                  onChange={(event) => onChange(field.name, event.target.value)}
                  className="w-full px-2 py-1.5 text-xs border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                >
                  <option value={field.allValue || ''}>{field.allLabel || 'Seçiniz'}</option>
                  {field.options && field.options.map((option) => (
                    <option key={option.value || option.id} value={option.value || option.id}>
                      {option.label || option.name || option.hotel_name || option.market || option.type || option.date_type || option.roomtype_name || option.is_maleonly || option.operator}
                    </option>
                  ))}
                </select>
              )}

              {field.type === 'date' && (
                <DatePicker
                  value={filters[field.name]}
                  onChange={(event) => onChange(field.name, event.target ? event.target.value : event)}
                  placeholder={field.placeholder || 'Tarih Seç'}
                  name={field.name}
                />
              )}

              {field.type === 'text' && (
                <input
                  type="text"
                  value={filters[field.name] || ''}
                  onChange={(event) => onChange(field.name, event.target.value)}
                  className="w-full px-2 py-1.5 text-xs border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                  placeholder={field.placeholder}
                />
              )}
            </div>
          );
        })}
      </div>

      <div className="flex items-center justify-start border-t border-gray-100 dark:border-gray-700 pt-3">
        <FilterActions onClear={onClear} onSearch={onSearch} />
      </div>
    </FilterPanel>
  );
};

export default DataFilter;
